import { Lists } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';

/**
 * Action to load the ProductLists
 */
export const loadProductLists = createAction(
  '[ProductList] Load Product Lists',
);

/**
 * Action for load ProductLists Sucess
 */
export const loadProductListsSuccess = createAction(
  '[ProductList] Load Product Lists Success',
  props<Lists>(),
);

/**
 * Action for load ProductLists Failure
 */
export const loadProductListsFailure = createAction(
  '[ProductList] Load Product Lists Failure',
);
